// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1___9957643fdb8f2e1e062","cls2":"Unibrow-cls2__bceed68d1d111ee48e71 Unibrow-cls1___9957643fdb8f2e1e062"};